import axios from 'axios';

// Return full responses to preserve the page's existing status-code checks.
export const getDesignPresets = () => axios.get(
  '/api/design-presets',
  { withCredentials: true },
);

export const updateDesignPreset = (presetId, preset) => axios.put(
  `/api/design-presets/${presetId}`,
  preset,
  { withCredentials: true },
);

export const createDesignPreset = (preset) => axios.post(
  '/api/design-presets',
  preset,
  { withCredentials: true },
);
